import { Box, CardContent, Chip } from '@material-ui/core'
import { IEventMetrics } from 'common/types/event.types'
import { useScreenSizes } from 'hooks/use-screen-sizes/useScreenSizes'
import { FC } from 'react'
//@ts-ignore
import styled from 'styled-components'
import { MetricCard } from './MetricCard'

const StyledChip = styled(Chip)<{ isDevice: boolean }>`
  && {
    font-weight: bold;
    padding: 0.1em 0.5em;
    border: 2px solid ${props => props.theme.colors.secondary};
    color: ${props => props.theme.colors.accent1};
    background-color: inherit;
    margin-left: ${({ isDevice }) => (isDevice ? 0 : '2em')};
    margin-bottom: ${({ isDevice }) => (isDevice ? '1em' : 'unset')};
  }
`

const VerticalBox = styled(Box)`
  && {
    border-left: 2px solid ${props => props.theme.colors.supplementary};
    height: 3em;
    margin:0 2.3em
  }
`

const MetricsCardContent = styled(CardContent)`
  && {
    &:last-child {
      padding: 10px !important;
    }
  }
`

const MetricsCardContentContainer = styled(CardContent)`
  && {
    align-items: center;
    justify-content: center;
    background-color: ${props => props.theme.colors.supplementary};
    border-radius: 10px;
    margin-top: 1rem;
  }
`

interface IEventMetric {
  registrantsTotalCount: number
  metrics: IEventMetrics[]
}

export const EventMetrics: FC<IEventMetric> = ({ registrantsTotalCount, metrics }) => {
  const { isDevice } = useScreenSizes()
  return (
    <Box
      width={isDevice ? '100%' : '100%'}
      padding={isDevice ? '0.3em' : 'unset'}
      ml={isDevice ? 0 : 0}
      maxWidth={isDevice ? '100%' : '100%'}
      mb="1em"
    >
      <MetricsCardContentContainer>
        <MetricsCardContent>
          <Box display="flex" flexDirection={isDevice ? 'column' : 'row'} alignItems={isDevice ? 'unset' : 'center'}>
            <Box display="flex" mr="3em">
              <StyledChip isDevice={isDevice} label="Metrics" />
            </Box>
            <Box
              display={isDevice ? 'grid' : 'flex'}
              gridTemplateColumns={isDevice ? '2fr 1fr 2fr' : 'unset'}
              justifyContent="center"
              alignItems="start"
              gridGap={isDevice ? 'auto' : '5em'}
              width="90%"
            >
              <MetricCard value={registrantsTotalCount} title={'Registrants'} />
              {!isDevice && <VerticalBox />}
              <MetricCard value={Number(metrics?.[0]?.attendedcount)} title={'Attended'} />
              <VerticalBox />
              <MetricCard value={Number(metrics?.[0]?.registrationcount)} title={'Not Attended'} />
            </Box>
          </Box>
        </MetricsCardContent>
      </MetricsCardContentContainer>
    </Box>
  )
}
